import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { ChangeEvent } from 'react';
import { Button, Checkbox } from '@repo/ui';

import { MODAL_STATE, useModalStore } from '@/components/modal/modal.store';
import { PrivacyDetails } from '@/components/welcome/components/privacy-details';
import { useMainHubStoreState } from '@/store/main-hub.store';

// Wykorzystywane na widoku 0
export const P24MarketingAgreementsFormInputs = ({ withTitle = true }: { withTitle?: boolean }) => {
  const { t } = useTranslation();
  const { merchantResponseData } = useMainHubStoreState();
  const { openModal } = useModalStore();
  const context = useFormContext();

  const { email: emailValue, tel: telValue, sms: smsValue } = context.watch();

  const isMerchantEmailComplete = Boolean(merchantResponseData?.data.merchantData.email);
  const isMerchantPhoneComplete = Boolean(merchantResponseData?.data.merchantData.phone);
  const isAllCheckboxesSelected = [smsValue, telValue, emailValue].every(Boolean);

  const onToggleAllPermissions = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      context.setValue('email', true);
      context.setValue('tel', true);
      context.setValue('sms', true);
    } else {
      context.setValue('email', false);
      context.setValue('tel', false);
      context.setValue('sms', false);
    }
  };

  return (
    <>
      {withTitle ? (
        <Typography
          fontSize={{ xs: 14, sm: 18, md: 20 }}
          fontWeight="bold"
          lineHeight="18px"
          sx={{ marginBottom: '11px' }}
        >
          {t('welcomePage.p24MarketingForm.letStayInTouch')}
        </Typography>
      ) : null}
      {isMerchantEmailComplete || isMerchantPhoneComplete ? (
        <Typography
          fontSize={{ xs: 10, sm: 12, md: 14, lg: 12, xl: 14 }}
          lineHeight={{ xs: '13px', sm: '16px', md: '18px' }}
          sx={{
            marginBottom: { md: '10px' },
          }}
        >
          {t('welcomePage.p24MarketingForm.description')}
        </Typography>
      ) : null}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 0, sm: 2 }}>
        {isMerchantEmailComplete || isMerchantPhoneComplete ? (
          <Checkbox
            label={t('welcomePage.p24MarketingForm.fields.selectAll')}
            checked={isAllCheckboxesSelected}
            name="selectAllCheckbox"
            variant="secondary"
            labelProps={{
              sx: {
                fontWeight: 'bold',
                fontSize: { lg: '12px', xl: '14px' },
              },
            }}
            onChange={onToggleAllPermissions}
          />
        ) : null}
        {isMerchantEmailComplete ? (
          <Checkbox
            label={t('welcomePage.p24MarketingForm.fields.email')}
            labelProps={{
              sx: {
                fontWeight: 'bold',
                fontSize: { lg: '12px', xl: '14px' },
              },
            }}
            name="email"
            variant="secondary"
          />
        ) : null}
        {isMerchantPhoneComplete ? (
          <Checkbox
            label={t('welcomePage.p24MarketingForm.fields.sms')}
            labelProps={{
              sx: {
                fontWeight: 'bold',
                fontSize: { lg: '12px', xl: '14px' },
              },
            }}
            name="sms"
            variant="secondary"
          />
        ) : null}
        {isMerchantPhoneComplete ? (
          <Checkbox
            label={t('welcomePage.p24MarketingForm.fields.phone')}
            labelProps={{
              sx: {
                fontWeight: 'bold',
                fontSize: { lg: '12px', xl: '14px' },
              },
            }}
            name="tel"
            variant="secondary"
          />
        ) : null}
      </Stack>
      <Typography variant="subtitle3">
        {t('welcomePage.p24MarketingForm.administratorInfo')}
      </Typography>
      <Button
        base
        onClick={() => {
          openModal(MODAL_STATE.LOAN_AGREEMENTS, <PrivacyDetails />);
        }}
      >
        <Typography component="span" variant="subtitle3" fontWeight={600}>
          {t('welcomePage.p24MarketingForm.readMore')}
        </Typography>
      </Button>
    </>
  );
};
